import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

// Handles the redirect back from Emergent-managed Google sign-in.
// The session_id arrives in the URL fragment and is exchanged once, then discarded.
export default function AuthCallback() {
  const { completeGoogleLogin } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }
    (async () => {
      try {
        const u = await completeGoogleLogin(sessionId);
        window.history.replaceState(null, '', window.location.pathname);
        navigate(u.role === 'admin' ? '/admin' : '/account', { replace: true, state: { user: u } });
      } catch {
        navigate('/login', { replace: true });
      }
    })();
  }, [completeGoogleLogin, navigate]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-brand-bone" data-testid="auth-callback">
      <p className="font-sans text-sm text-brand-muted">Signing you in…</p>
    </div>
  );
}
